package com.github.jangalinski.tabweb._foundation.alignment

import com.varabyte.kobweb.compose.ui.Alignment

data object TOP : Vertical, CardinalDirection {
  val alignment: Alignment.Vertical = Alignment.Top
}
